(() => {
  const init = (bundle) => {
    if (bundle.dataset.initialized === 'true') return;
    bundle.dataset.initialized = 'true';

    const plans = [...bundle.querySelectorAll('.mp-native-plan')];
    const addButton = bundle.querySelector('.mp-native-bundle__atc');
    const error = bundle.querySelector('.mp-native-bundle__error');
    const progress = bundle.querySelector('.mp-native-progress');
    const progressSteps = [...bundle.querySelectorAll('.mp-native-progress__step')];
    const progressMessage = bundle.querySelector('.mp-native-progress__message span');
    const upsell = bundle.querySelector('[data-wallet-upsell]');
    const upsellSwitch = upsell?.querySelector('[role="switch"]');
    const modelButtons = [...(upsell?.querySelectorAll('[data-upsell-model]') || [])];
    const upsellImage = upsell?.querySelector('[data-upsell-image]');
    const colorButtons = [...bundle.querySelectorAll('[data-variant-id]')];
    const selectedColor = bundle.querySelector('[data-selected-color]');
    let selectedPlan = plans.find((plan) => plan.classList.contains('is-selected')) || plans[0];
    let selectedVariant = colorButtons.find((button) => button.classList.contains('is-selected')) || colorButtons[0];
    let upsellEnabled = false;
    let upsellModel = 'apple';
    const packImages = {
      noir: {
        1: 'https://cdn.shopify.com/s/files/1/0984/9490/6647/files/compresseur-noir-1-sac_2714c225-f506-4d2b-afd8-2751fed37389.webp?v=1790608162',
        3: 'https://cdn.shopify.com/s/files/1/0984/9490/6647/files/compresseur-noir-3-sacs_cba0ae82-7693-438e-bd8d-16b17f30af0d.webp?v=1790608162',
        5: 'https://cdn.shopify.com/s/files/1/0984/9490/6647/files/compresseur-noir-5-sacs_56e84428-46dd-49b8-8838-23e1febd5b10.webp?v=1790608162'
      },
      gris: {
        1: 'https://cdn.shopify.com/s/files/1/0984/9490/6647/files/compresseur-gris-1-sac_78e8cc7c-6047-4e31-bb1b-bb0d2ced6882.webp?v=1790608162',
        3: 'https://cdn.shopify.com/s/files/1/0984/9490/6647/files/compresseur-gris-3-sacs_4ba8ed4a-9c71-4a11-ae36-af76b755aac5.webp?v=1790608162',
        5: 'https://cdn.shopify.com/s/files/1/0984/9490/6647/files/compresseur-gris-5-sacs_a667783e-b8c8-48d9-ae3a-90fbbfca8ecd.webp?v=1790608162'
      },
      marron: {
        1: 'https://cdn.shopify.com/s/files/1/0984/9490/6647/files/compresseur-marron-1-sac_53321c9b-3723-4ccd-80ea-124f00a27d40.webp?v=1790608162',
        3: 'https://cdn.shopify.com/s/files/1/0984/9490/6647/files/compresseur-marron-3-sacs_b34aa803-41a9-4315-a01e-59596298a1ab.webp?v=1790608162',
        5: 'https://cdn.shopify.com/s/files/1/0984/9490/6647/files/compresseur-marron-5-sacs_b4e178d4-2203-454c-8bb6-f4c8ab374da5.webp?v=1790608162'
      },
      vert: {
        1: 'https://cdn.shopify.com/s/files/1/0984/9490/6647/files/compresseur-vert-1-sac_e7d78ffb-c45c-497a-8357-174baf8de5e0.webp?v=1790608162',
        3: 'https://cdn.shopify.com/s/files/1/0984/9490/6647/files/compresseur-vert-3-sacs_b980f9ed-1f21-445e-b570-32bf8e44b807.webp?v=1790608162',
        5: 'https://cdn.shopify.com/s/files/1/0984/9490/6647/files/compresseur-vert-5-sacs_baf66f77-ac1b-429d-b9be-371a97d4e2dd.webp?v=1790608162'
      }
    };

    const simplifyProductGallery = () => {
      if (bundle.dataset.productHandle !== 'vacuum-compression-bag') return;
      document.querySelectorAll('img[alt^="Minimal Paris — compresseur "]').forEach((image) => {
        let media = image.parentElement;
        while (media && !media.hasAttribute('data-media-id')) media = media.parentElement;
        if (media) media.hidden = true;
      });
    };

    const openCartDrawer = (pending = false) => {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      drawer.classList.toggle('mp-cart-pending', pending);
      drawer.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
    };

    const replaceSection = (id, html) => {
      if (!html) return;
      const current = document.getElementById(id);
      const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(id);
      if (current && fresh) current.innerHTML = fresh.innerHTML;
    };

    const renderCart = (payload) => {
      const sections = payload?.sections;
      if (!sections) return;
      replaceSection('CartDrawer', sections['cart-drawer']);
      replaceSection('cart-icon-bubble', sections['cart-icon-bubble']);
      const drawer = document.querySelector('cart-drawer');
      const renderedDrawer = new DOMParser().parseFromString(sections['cart-drawer'] || '', 'text/html').querySelector('cart-drawer');
      if (drawer && renderedDrawer) drawer.classList.toggle('is-empty', renderedDrawer.classList.contains('is-empty'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: payload }));
    };

    const render = () => {
      plans.forEach((plan) => {
        const active = plan === selectedPlan;
        plan.classList.toggle('is-selected', active);
        plan.setAttribute('aria-checked', String(active));
      });
      modelButtons.forEach((button) => {
        const active = button.dataset.upsellModel === upsellModel;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
      });
      if (upsellSwitch) upsellSwitch.setAttribute('aria-checked', String(upsellEnabled));
      if (upsellImage) {
        upsellImage.src = upsellModel === 'android' ? bundle.dataset.trackerAndroidImage : bundle.dataset.trackerAppleImage;
        upsellImage.alt = `Le Tracker Minimal Paris — ${upsellModel === 'android' ? 'Android' : 'Apple'}`;
      }
      colorButtons.forEach((button) => {
        const active = button === selectedVariant;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-checked', String(active));
      });
      if (selectedVariant) {
        bundle.dataset.walletVariant = selectedVariant.dataset.variantId;
        if (selectedColor) {
          selectedColor.textContent = selectedVariant.dataset.variantTitle || '';
          selectedColor.className = `mp-native-color-label mp-native-color-label--${selectedVariant.dataset.colorKey || ''}`;
        }
        const mediaId = selectedVariant.dataset.mediaId;
        const media = mediaId && document.querySelector(`[data-media-id$="-${mediaId}"]`);
        media?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      /* Palier / progression pilotés par les data-attributes rendus côté Liquid
         (configurables depuis le Theme Editor) — aucune quantité hard-codée. */
      const stepCount = progressSteps.length || plans.length || 1;
      const stage = Number(selectedPlan.dataset.stage) || (plans.indexOf(selectedPlan) + 1);
      const colorKey = selectedVariant?.dataset.colorKey;
      const quantity = Number(selectedPlan.dataset.quantity);
      const image = packImages[colorKey]?.[quantity] || selectedPlan.getAttribute(`data-image-${colorKey}`) || selectedVariant?.dataset.image;
      plans.forEach((plan) => {
        const planQuantity = Number(plan.dataset.quantity);
        const planImage = packImages[colorKey]?.[planQuantity] || plan.getAttribute(`data-image-${colorKey}`) || selectedVariant?.dataset.image;
        if (planImage) {
          plan.querySelectorAll('.mp-native-plan__visual img, .mp-native-plan__benefits img').forEach((element) => {
            element.src = planImage;
          });
        }
      });
      if (image) bundle.dataset.stickyImage = image;
      colorButtons.forEach((button) => {
        const thumbnail = button.querySelector('.mp-native-color__image img');
        const thumbnailImage = packImages[button.dataset.colorKey]?.[quantity] || button.dataset.image;
        if (thumbnail && thumbnailImage) thumbnail.src = thumbnailImage;
      });
      addButton.querySelector('strong').textContent = selectedPlan.dataset.price || '';
      progress.dataset.stage = String(stage);
      progress.style.setProperty('--mp-progress', stepCount > 1 ? `${Math.round(((stage - 1) / (stepCount - 1)) * 100)}%` : '100%');
      progressSteps.forEach((step, index) => step.classList.toggle('is-active', index < stage));
      if (progressMessage) progressMessage.textContent = selectedPlan.dataset.progressMsg || progressMessage.textContent;
    };

    plans.forEach((plan) => plan.addEventListener('click', () => {
      selectedPlan = plan;
      render();
    }, true));
    modelButtons.forEach((button) => button.addEventListener('click', () => {
      upsellModel = button.dataset.upsellModel;
      render();
    }));
    colorButtons.forEach((button) => button.addEventListener('click', () => {
      selectedVariant = button;
      render();
    }));
    upsellSwitch?.addEventListener('click', () => {
      upsellEnabled = !upsellEnabled;
      render();
    });

    const country = bundle.querySelector('[data-country-code]');
    if (country) {
      const code = (country.dataset.countryCode || '').trim().toUpperCase();
      if (/^[A-Z]{2}$/.test(code)) country.textContent = String.fromCodePoint(...[...code].map((letter) => 127397 + letter.charCodeAt(0)));
    }

    addButton.addEventListener('click', async () => {
      const quantity = Number(selectedPlan.dataset.quantity);
      const walletVariant = Number(bundle.dataset.walletVariant);
      if (!walletVariant || !quantity) return;

      const offer = selectedPlan.dataset.offer || `${quantity} portefeuille${quantity > 1 ? 's' : ''}`;
      const items = [{ id: walletVariant, quantity, properties: { '_Offre Minimal Paris': offer } }];
      if (upsellEnabled) {
        const trackerVariant = Number(upsellModel === 'android' ? bundle.dataset.trackerAndroid : bundle.dataset.trackerApple);
        if (trackerVariant) items.push({ id: trackerVariant, quantity: 1, properties: { '_Ajout populaire': 'Avec Le Portefeuille' } });
      }

      const label = addButton.querySelector('span');
      const originalLabel = label ? label.textContent : '';
      addButton.disabled = true;
      addButton.classList.add('is-loading');
      addButton.setAttribute('aria-busy', 'true');
      if (label) label.textContent = 'AJOUT EN COURS...';
      error.hidden = true;
      /* on n'ouvre plus le tiroir avant d'avoir la réponse (évite l'écran "Ajout de
         votre offre..." vide pendant 1 à 3 secondes) : le bouton porte l'état de
         chargement, le tiroir ne s'ouvre qu'une fois rempli avec le contenu réel. */
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
        });
        if (!response.ok) throw new Error('Could not add to cart');
        renderCart(await response.json());
        openCartDrawer(false);
      } catch (exception) {
        document.querySelector('cart-drawer')?.classList.remove('mp-cart-pending');
        error.textContent = 'Something went wrong. Please try again in a few seconds.';
        error.hidden = false;
      } finally {
        addButton.disabled = false;
        addButton.classList.remove('is-loading');
        addButton.removeAttribute('aria-busy');
        if (label) label.textContent = originalLabel;
      }
    });

    render();
    simplifyProductGallery();
    window.setTimeout(simplifyProductGallery, 600);

    const restoreCompresseurFaq = () => {
      if (bundle.dataset.productHandle !== 'vacuum-compression-bag') return;
      const faq = document.querySelector('[id$="__collapsible_content_qVriXV"]');
      const placeholder = document.querySelector('.mp-faq-placeholder');
      if (faq && placeholder && placeholder.parentNode && faq.parentNode !== placeholder.parentNode) {
        placeholder.parentNode.insertBefore(faq, placeholder.nextSibling);
        faq.classList.remove('mp-faq-docked');
      }
    };
    restoreCompresseurFaq();
    window.setTimeout(restoreCompresseurFaq, 1800);

    const setTravelPromo = () => {
      if (bundle.dataset.productHandle !== 'vacuum-compression-bag') return;
      const promo = document.querySelector('.mp-promo');
      const label = promo?.querySelector('.mp-promo__label');
      if (!promo || !label || promo.dataset.travelPromo === 'true') return;
      promo.dataset.travelPromo = 'true';
      promo.classList.add('mp-promo--travel');
      const message = 'Get ready for your next trip ✈️ · Free shipping over $59 · Easy 30-day returns';
      label.innerHTML = `<span class="mp-promo__track"><span>${message}</span><span aria-hidden="true">${message}</span></span>`;
    };
    setTravelPromo();
    window.setTimeout(setTravelPromo, 250);
  };

  const initAll = () => document.querySelectorAll('.mp-wallet-bundle').forEach(init);
  initAll();
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
